/** @jsx jsx */
import { jsx, Box, Flex, Heading, Image, Link } from "theme-ui"
import logo from "../images/logo-associations-monnieroises.png"

export default function Header(props) {
  return (
    <header {...props} sx={{ p: 3 }}>
      <Link href="/" sx={{ display: 'flex', width: 'fit-content', textDecoration: 'none' }}>
        <Image src={logo} alt="" width={61} height={72} sx={{ alignSelf: 'flex-start' }} />
        <Flex sx={{ flexDirection: 'column', justifyContent: 'center', ml: 3 }}>
          <Heading as="h1" sx={{ fontSize: [3, 4] }}>Associations monniéroises</Heading>
          <Box>Annuaire des associations de Monnières en Loire-Atlantique</Box>
        </Flex>
      </Link>
    </header>
  )
}
